"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ShippingSamples = function ShippingSamples(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#F96302' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {
    translate: function translate(text) {
      return text;
    }
  } : _ref$langContext,
      translateKey = _ref.translateKey;
  var iconSize = size === 'original' ? 'width="17" height="17"' : 'width="100%"';
  var title;

  if (translateKey) {
    title = translateKey('shipToHome');
  } else {
    title = langContext.translate('Shipping Icon');
  }

  return "\n  <svg role=\"img\" aria-label=\"".concat(title, "\" ").concat(iconSize, " viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title>").concat(title, "</title>  \n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.01135 7.00424V16.0148L11.9899 21.994V13.0103L2.01135 7.00424ZM13.0119 12.4001V21.3944L22.0002 16.0148V7.00984L13.0119 12.4001ZM12.0013 21.9992H11.9987L12 22L12.0013 21.9992ZM12 12L7.82436 9.50379L16.5479 4.27231L21.1198 6.55954L12 12ZM2.89586 6.5575L7.02782 9.02761L15.6802 3.83825L12.0058 2L2.89586 6.5575Z\" fill=\"").concat(color, "\"/>\n  </svg>\n    ");
};

var _default = ShippingSamples;
exports["default"] = _default;